var $ = require('jquery');
var Select = require('./selectric/selectric');
var MobileNav = require('./MobileNav/MobileNav');
var banner = require('./banner/banner');
var matchHeight = require('./matchHeight/matchHeight');
var ContactMap = require('./Map/map');
var PropertyMap = require('./Map/propertyMap');
var loadMoreNews = require('./load-more/news');
var loadMoreProperty = require('./load-more/property');
var PropertyImages = require('./PropertyImages/PropertyImages');
var PropertyTabs = require('./PropertyTabs/PropertyTabs');
var Shave = require('./Shave/Shave');

$(function(){
  Select();
  MobileNav();
  banner();
  Shave();
  matchHeight();
  loadMoreNews();
  loadMoreProperty();
  PropertyImages();
  //PropertyTabs();
  ContactMap(window.__CONFIG__.google_api_key);
  PropertyMap(window.__CONFIG__.google_api_key);

  $(".team-member").click(function(){
    $(".team-member__overlay").hide();
    $(this).children(".team-member__overlay").show();
  });

  $(".js-tab-trigger").click(function(){
    var $this = $(this);
    var id = $this.data("tab");
    var $new = $(".js-tab-content[data-tab='" + id + "']");
    $(".js-tab-trigger, .js-tab-content").removeClass("active");
    $this.addClass("active");
    $new.addClass("active");
  });

  $(".sort-by").change(function(e) {
    var $this = $(this);
    var filter = $this.val();
    var currentUrl = window.location.href;
    var url = '';

    if($this.is("#category_filter")) {
      if(filter == "category"){
        url = currentUrl.split('?')[0];
      } else {
        currentUrl = currentUrl.split('?')[0];
        url = currentUrl+"?cat="+filter;
      }
    } else if($this.is("#sort_filter")) {
      if (currentUrl.includes("/?")) {
        url = currentUrl.split('&')[0];
        url = url+"&order="+filter;
      } else {
        url = currentUrl+"?order="+filter;
      }
    }

    if(currentUrl !== url) window.location = url;
    return false;
  });

  $('.share__button').click(function(){
    $(this).fadeOut(300);
    $('.share__list').delay(300).fadeIn(300);
  });

   $(".post__caption").css({
    'width': ($(".post__image img").width() + 'px')
  });

  $('.load-more__link').on('click', function(e){
        e.preventDefault();
        var $btn = $(this);
        $btn.hide();
        var max = $btn.data('page-total');
        var addTo = $(this).data('addto');

        var query = window.location.search;
        var path = window.location.pathname.replace(/\/+$/g,"");
        var urlElems = path.split('/');
        var lastElem = urlElems[urlElems.length - 1];
        var nextPage = 2;

        var nextPageLink = $btn.attr('href');
        var nextPageLinkElems = nextPageLink.replace(/\/+$/g,"");
        nextPageLinkElems = nextPageLinkElems.split('/');
        nextPageLastElem = urlElems[urlElems.length - 1];
        if(Number.isInteger(parseInt(nextPageLastElem))){
            nextPage = nextPageLastElem;
        }

        if(Number.isInteger(parseInt(lastElem))){
            var nextPage = parseInt(lastElem) + 1;
            urlElems.splice(urlElems.length - 1, 2);
        }
        var url = urlElems.join('/');
        url += '/page/'+nextPage;
        if(query.length){
            url += query;
        }
        var futureNextURL = urlElems.join('/');
        futureNextURL += '/page/'+(nextPage + 1);
        if(query.length){
            futureNextURL += query;
        }
        $.get(url, function(data){
            var output = $(data).find('#'+addTo).html();
            $('#'+addTo).append(output);
            if(max >= (nextPage + 1)){
                $btn.attr('href', futureNextURL);
                $btn.show();
            }
            if($btn.data('match-height').length > -1){
                $('.'+$btn.data('match-height')).matchHeight();
            }
        });
    });

});
